import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/ProtectedRoute';
import { useAuth } from './providers/AuthProvider';

import Login from './pages/Login';
import LoginCreateAccount from './pages/LoginCreateAccount';
import LoginCheckValid from './pages/LoginCheckValid';
import LoginChoice from './pages/LoginChoice';
import LoginForgotPassword from './pages/LoginForgotPassword';
import LoginForgotPassword2 from './pages/LoginForgotPassword2';

import Main from './pages/Main';
import MainHome from './pages/MainHome';
import MainPets from './pages/MainPets';
import MainOwners from './pages/MainOwners';
import MainAgenda from './pages/MainAgenda';
import MainDailyCash from './pages/MainDailyCash';
import MainReports from './pages/MainReports';
import MainAbout from './pages/MainAbout';

//edits
import EditVet from './pages/edit/EditVet';
import EditOwner from './pages/edit/EditOwner';
import EditPet from './pages/edit/EditPet';
import EditVetServiceAssoc from './pages/edit/EditVetServiceAssoc';
import EditVetSchedule from './pages/edit/EditVetSchedule';
import EditVetPoint from './pages/edit/EditVetPoint';
import EditVetDeposit from './pages/edit/EditVetDeposit';
import EditUser from './pages/edit/EditUser';
import EditClinic from './pages/edit/EditClinic';
import EditClinic2 from './pages/edit/EditClinic2';
import EditStudy from './pages/edit/EditStudy';
import EditSell from './pages/edit/EditSell';
import EditMovement from './pages/edit/EditMovement';
import EditSupply from './pages/edit/EditSupply';
import EditRecipe from './pages/edit/EditRecipe';
import EditAgenda from './pages/edit/EditAgenda';
import EditProduct from './pages/edit/EditProduct';
import EditService from './pages/edit/EditService';
import EditSpending from './pages/edit/EditSpending';
import EditPurchase from './pages/edit/EditPurchase';
import EditManualCash from './pages/edit/EditManualCash';
import EditProvider from './pages/edit/EditProvider';
import EditImport from './pages/edit/EditImport';
import EditProductAssoc from './pages/edit/EditProductAssoc';

//search
import SearchVet from './pages/search/SearchVet';
import SearchManufacturer from './pages/search/SearchManufacturer';
import SearchOwner from './pages/search/SearchOwner';
import SearchPet from './pages/search/SearchPet';
import SearchProduct from './pages/search/SearchProduct';
import SearchUser from './pages/search/SearchUser';
import SearchProvider from './pages/search/SearchProvider';
import SearchTreatment from './pages/search/SearchTreatment';
import SearchSymptom from './pages/search/SearchSymptom';
import SearchDiagnostic from './pages/search/SearchDiagnostic';

//views
import ViewOwner from './pages/view/ViewOwner';
import ViewOwnerDebts from './pages/view/ViewOwnerDebts';
import ViewVet from './pages/view/ViewVet';
import ViewUser from './pages/view/ViewUser';
import ViewPet from './pages/view/ViewPet';
import ViewManufacturer from './pages/view/ViewManufacturer';
import ViewProduct from './pages/view/ViewProduct';
import ViewVetServicesSchedules from './pages/view/ViewVetServicesSchedules';
import ViewVetUsers from './pages/view/ViewVetUsers';
import ViewVetPoints from './pages/view/ViewVetPoints';
import ViewVetDeposits from './pages/view/ViewVetDeposits';
import ViewSell from './pages/view/ViewSell';
import ViewProvider from './pages/view/ViewProvider';
import ViewProviderDebts from './pages/view/ViewProviderDebts';
import ViewAgendaEvent from './pages/view/ViewAgendaEvent';
import ViewDailyCashDetails from './pages/view/ViewDailyCashDetails';
import ViewPurchase from './pages/view/ViewPurchase';
import ViewSpending from './pages/view/ViewSpending';
import ViewCashMovement from './pages/view/ViewCashMovement';
import ViewMovement from './pages/view/ViewMovement';
import ViewVetChange from './pages/view/ViewVetChange';

// camera
import CameraCapture from './pages/CameraCapture';

function App() {
  const { isAuth } = useAuth();

  return (
    <Router basename="/app">
      <Routes>

        {/* public */}
        <Route path="/" element={ isAuth ? <Navigate to="/main" /> : <Login /> } />        
        <Route path="login-create-account" element={<LoginCreateAccount />} />
        <Route path="login-check-valid" element={<LoginCheckValid />} />
        <Route path="login-choice" element={<LoginChoice />} />
        <Route path="login-forgot-password" element={<LoginForgotPassword />} />
        <Route path="login-forgot-password-2" element={<LoginForgotPassword2 />} />
        <Route path="edit-vet" element={<EditVet />} />
        <Route path="search-vet" element={<SearchVet />} />
        
        {/* private */}
        <Route
          path="main"
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        >
          {/* home redirect */}
          <Route index element={<Navigate to="home" replace />} />

          {/* sections */}
          <Route path="home" element={<MainHome />} />
          <Route path="pets" element={<MainPets />} />
          <Route path="owners" element={<MainOwners />} />
          <Route path="agenda" element={<MainAgenda />} />
          <Route path="reports" element={<MainReports />} />
          <Route path="daily-cash" element={<MainDailyCash />} />
          <Route path="about" element={<MainAbout />} />

          {/* edits */}
          <Route path="edit-owner" element={<EditOwner />} />
          <Route path="edit-pet" element={<EditPet />} />
          <Route path="edit-vet-service-assoc" element={<EditVetServiceAssoc />} />
          <Route path="edit-vet-schedule" element={<EditVetSchedule />} />
          <Route path="edit-vet-point" element={<EditVetPoint />} />
          <Route path="edit-vet-deposit" element={<EditVetDeposit />} />
          <Route path="edit-user" element={<EditUser />} />
          <Route path="edit-clinic" element={<EditClinic />} />
          <Route path="edit-clinic2" element={<EditClinic2 />} />
          <Route path="edit-study" element={<EditStudy />} />
          <Route path="edit-sell" element={<EditSell />} />
          <Route path="edit-movement" element={<EditMovement />} />
          <Route path="edit-supply" element={<EditSupply />} />
          <Route path="edit-recipe" element={<EditRecipe />} />
          <Route path="edit-agenda" element={<EditAgenda />} />
          <Route path="edit-product" element={<EditProduct />} />
          <Route path="edit-service" element={<EditService />} />
          <Route path="edit-spending" element={<EditSpending />} />
          <Route path="edit-purchase" element={<EditPurchase />} />
          <Route path="edit-manual-cash" element={<EditManualCash />} />
          <Route path="edit-provider" element={<EditProvider />} />
          <Route path="edit-import" element={<EditImport />} />
          <Route path="edit-product-assoc" element={<EditProductAssoc />} />

          {/* search */}
          <Route path="search-manufacturer" element={<SearchManufacturer />} />
          <Route path="search-owner" element={<SearchOwner />} />
          <Route path="search-pet" element={<SearchPet />} />
          <Route path="search-product" element={<SearchProduct />} />
          <Route path="search-user" element={<SearchUser />} />
          <Route path="search-provider" element={<SearchProvider />} />
          <Route path="search-treatment" element={<SearchTreatment />} />
          <Route path="search-symptom" element={<SearchSymptom />} />
          <Route path="search-diagnostic" element={<SearchDiagnostic />} />
          
          {/* views */}
          <Route path="view-owner" element={<ViewOwner />} />
          <Route path="view-owner-debts" element={<ViewOwnerDebts />} />
          <Route path="view-pet" element={<ViewPet />} />
          <Route path="view-vet" element={<ViewVet />} />
          <Route path="view-user" element={<ViewUser />} />
          <Route path="view-manufacturer" element={<ViewManufacturer />} />
          <Route path="view-product" element={<ViewProduct />} />
          <Route path="view-vet-services-schedules" element={<ViewVetServicesSchedules />} />
          <Route path="view-vet-users" element={<ViewVetUsers />} />
          <Route path="view-vet-points" element={<ViewVetPoints />} />
          <Route path="view-vet-deposits" element={<ViewVetDeposits />} />
          <Route path="view-sell" element={<ViewSell />} />
          <Route path="view-provider" element={<ViewProvider />} />
          <Route path="view-provider-debts" element={<ViewProviderDebts />} />
          <Route path="view-agenda-event" element={<ViewAgendaEvent />} />
          <Route path="view-daily-cash-details/:date" element={<ViewDailyCashDetails />} />
          <Route path="view-purchase" element={<ViewPurchase />} />
          <Route path="view-spending" element={<ViewSpending />} />
          <Route path="view-cash-movement" element={<ViewCashMovement />} />
          <Route path="view-movement" element={<ViewMovement />} />
          <Route path="view-vet-change" element={<ViewVetChange />} />
          
          {/* camera */}
          <Route path="camera-capture" element={<CameraCapture />} />
          
        </Route>

      </Routes>
    </Router>
  )
}

export default App